module.exports = __webpack_public_path__ + "static/media/mortgages_portal.ea932e94.jpg";